<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ser"><img alt="9781618371621_0028_001" id="d7e809428" src="Images/9781618371621_0028_001.jpg" style="max-width:100%;"/></p>
<p class="cap"><a class="hlink" href="#/Text/West_9781618371621_epub_c14_r1#d7e902332"><i>Perfect Guacamole</i></a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c8_r1.vue?fa49add2